import React from 'react';

import PageHeader from '../PageHeader/PageHeader';
import PageHeaderText from '../PageHeader/PageHeaderText';
import PageHeaderImage from '../PageHeader/PageHeaderImage';

const CaseStudyHeader = ({
	title,
	text,
	image,
	alt,
	links,
	techUsed,
	sourceLinks
}) => {
	return (
		<PageHeader>
			<PageHeaderText
				title={title}
				techUsed={techUsed}
				sourceLinks={sourceLinks}>
				{text}
			</PageHeaderText>
			<PageHeaderImage image={image} alt={alt}>
				{links}
			</PageHeaderImage>
		</PageHeader>
	);
};

export default CaseStudyHeader;
